/**
 * LexikonGrid Component
 * Displays lexicon items in grid or list view
 */

import React from "react";
import type { Language, LexiconItem, ViewMode } from "../types";
import LexikonCard from "./LexikonCard";

interface LexikonGridProps {
  items: LexiconItem[];
  language: Language;
  viewMode: ViewMode;
  onItemClick: (item: LexiconItem) => void;
  searchQuery?: string;
  emptyMessage?: string;
}

const LexikonGrid: React.FC<LexikonGridProps> = ({
  items,
  language,
  viewMode,
  onItemClick,
  searchQuery = "",
  emptyMessage,
}) => {
  // Empty state
  if (items.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">🔍</div>
        <h3 className="empty-state-title">
          {language === "cs" ? "Nic nenalezeno" : "Nothing found"}
        </h3>
        <p className="empty-state-text">
          {emptyMessage ||
            (language === "cs"
              ? "Zkuste upravit vyhledávání nebo filtry"
              : "Try adjusting your search or filters")}
        </p>
      </div>
    );
  }

  // Render items
  const isCompact = viewMode === "compact";
  const containerClass = viewMode === "list" ? "lexikon-list" : "lexikon-grid";

  return (
    <div className={containerClass} role="list">
      {items.map((item) => (
        <LexikonCard
          key={item.id}
          item={item}
          language={language}
          onClick={onItemClick}
          isCompact={isCompact}
          searchQuery={searchQuery}
        />
      ))}
    </div>
  );
};

export default LexikonGrid;
